import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\AddAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource'
*/
const AddAssignedMaterialResourceController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddAssignedMaterialResourceController.url(args, options),
    method: 'post',
})

AddAssignedMaterialResourceController.definition = {
    methods: ["post"],
    url: '/api/planning/{event}/material-resource',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\AddAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource'
*/
AddAssignedMaterialResourceController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return AddAssignedMaterialResourceController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\AddAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/AddAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource'
*/
AddAssignedMaterialResourceController.post = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddAssignedMaterialResourceController.url(args, options),
    method: 'post',
})

export default AddAssignedMaterialResourceController